import { Component, OnDestroy, OnInit, Renderer2, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { AppService } from '../shared/services/app.service';
import { ReportDataRxjsService } from '../shared/services/report-data-rxjs.service';
// import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';

declare var $: any;
import {
  faMountain,
  faInfoCircle,
  faFileExport,
  faLightbulb,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faBoxOpen,
  faCircle,
  faSitemap,
  faPlusSquare,
  faEdit,
  faTrash,
  faRedo,
  faSave
} from '@fortawesome/free-solid-svg-icons';
import { TaskPlannerComponent } from '../task-planner/task-planner.component';
import { Subscription } from 'rxjs';
import { SocketService } from '../shared/services/socket.service';
import { faJira } from '@fortawesome/free-brands-svg-icons';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { MainComponent } from '../main/main.component';
import { Config } from '../config';
// @Pipe({
//   name: 'filter'
// })
@Component({
  selector: 'app-landscaper',
  templateUrl: './landscaper.component.html',
  styleUrls: ['./landscaper.component.scss'],
})
export class LandscaperComponent implements OnInit, OnDestroy {
  faCircle = faCircle;
  faSitemap = faSitemap;
  faMountain = faMountain;
  faInfoCircle = faInfoCircle;
  faFileExport = faFileExport;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  faBoxOpen = faBoxOpen;
  faJira = faJira;
  faPlusSquare = faPlusSquare;
  faEdit = faEdit;
  faTrash = faTrash;
  faLightbulb = faLightbulb;
  faRedo = faRedo;
  faSave = faSave;

  clickEventsubscriptionSocket: Subscription;
  proDataSubscription: Subscription = new Subscription();
  composer: any;
  currentView: any;
  modules: any;
  listOfAttributes: any;
  listOfEnv: any;
  listOfEUTs: any;
  childrenArray: any;
  nodeData: any;
  mindMapData: any;
  modulesData: any;
  syncModelDataObject: any;
  // ReportDataRxjsService: any;

  constructor(
    // public translate: TranslateService,
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private reloadToolService: ReloadToolService,
    private socketService: SocketService,
    private mainComponent: MainComponent,
    public taskPlannerComponent: TaskPlannerComponent,
    public appService: AppService,
    public Config: Config,
    private ReportDataRxjsService: ReportDataRxjsService,
    private renderer: Renderer2
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
  }

  matchedEditPersona: any;
  persona: any;
  selectedPersonaObj: any = {};
  selectedEditPersona: any = '';
  selectedEntityObj: any = {};
  selectedEditEntity: any = '';
  selectedModuleObj: any = {};
  selectedEditModule: any = '';
  selectedEnvObj: any = {};
  selectedEditEnvType: any = '';
  selectedEditEnvValues: any = '';
  selectedOldEntity: any = '';
  selectedOldModule: any = '';
  matchedEntity: any = '';
  entityModel: any;
  newCreatedID: any;
  AppService: any;
  matchedPersona: any;
  newPersonaID: any;
  scenarios: any;
  model: any;
  planner: any;
  loginDetails: any;
  userName: any;
  lsModel: any = {};
  token: any;
  projectsLoaded: any;
  EntityType: any = false;
  smartChecklist: boolean = true;
  projects: any;
  currProject: any;
  modelData: any;
  landscape: any;
  primaryEntity = true;
  entityType = 'TF';
  tabType = 'module';
  types = ["NEW", "MOD", "FIX"];
  entityTypes = ["XX", "TF", "UR", "BF"];
  choosenType = 'NEW';
  choosenEntityType = 'UR';
  choosenPrimaryEntity = {
    "eName": '',
    "eID": ''
  };
  choosenModule = {
    "mName": '',
    "mID": ''
  };
  duplicateEntity: any;
  duplicateModule: any;
  errorMessage: any;
  latUpdatedmodelData: any;
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  jiraProjectData: any;
  currentTab: any = 'persona';
  jiraInterfaceDisabled: boolean = false;
  ngOnInit(): void {
    this.mainComponent.activateLoader(true);
    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    // // console.log('this.loginDetails', this.loginDetails);
    this.userName = this.loginDetails.user_display_name;
    this.token = this.loginDetails.token;
    // this.getProjectList(this.token);
    // this.modelData = this._sharedService.loadedProjectData.model;
    this.proDataSubscription = this._sharedService.projectJsonSubject.subscribe(data => {
      this.modelData = data.model;
    });
    // this.latUpdatedmodelData = this._sharedService.loadedProjectData.model;
    this.persona = this.modelData.persona;
    // console.log('lsModel', this.modelData);
    if (this.modelData.modules.length > 0) {
      this.chooseModule(this.modelData.modules[0]);

    }
    // this.modelData.listOfAttributes = [];
    this.persona = this.modelData.persona;
    this.modulesData = this.modelData.modules;
    this.listOfAttributes = this.modelData.listOfAttributes;
    this.listOfEnv = this.modelData.listOfEnv;
    this.listOfEUTs = this.modelData.listOfEUTs;
    // if (this.modelData.modules) {
    // }
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    setTimeout(() => {
      this.getVideoURL('Ls');
      this.jiraProjectData = this._sharedService.jiraProjectData;
      // console.log('this.jiraProjectData', this.jiraProjectData);
      if (this.jiraProjectData.length === 0) {
        this.jiraInterfaceDisabled = true;
      }
    }, 2000);
    this.reloadToolService.triggerSmartChecklist('');
    // this.modelData.persona = [];
    // this.getMindMappingData()
    this.mainComponent.activateLoader(false);
  }

  ngOnDestroy() {
    this.proDataSubscription.unsubscribe();
  }
  changePriorTab(tabName: any) {
    this.currentTab = tabName;
  }
  chooseType(type: any) {
    this.choosenType = type;
    if (type == 'MOD' || type == 'FIX') {
      this.primaryEntity = false;
    } else {
      this.primaryEntity = true;
    }
    this.choosenPrimaryEntity = {
      "eName": '',
      "eID": ''
    };
  }
  choosePrimaryEUT(eut: any) {
    if (eut == '') {
      this.choosenPrimaryEntity.eName = 'anonymous'
    } else {
      this.choosenPrimaryEntity = eut;
    }
  }
  chooseeType(eType: any) {
    this.choosenEntityType = eType;
  }
  chooseModule(module: any) {

    this.choosenModule = module;
    this.clearEntityDetails();
  }
  changeTab(type: any) {
    this.tabType = type;
  }

  selectedPersona(persona: any) {
    // $('#personatextarea').val('');
    this.selectedPersonaObj = persona;
    this.selectedEditPersona = persona.pName;
  }
  selectedModule(module: any) {
    // $('#entitytextareaTF').val('');
    // $('#entitytextareaUR').val('');
    // $('#entitytextareaBF').val('');
    this.selectedModuleObj = module;
    this.selectedEditModule = module.mName;
    this.choosenModule = module;
  }
  openTool(toolname: any) {
    this.currentView = toolname;
    localStorage.setItem('currentTool', toolname);
  }
  selectedEntity(entity: any) {
    // console.log(entity);
    this.selectedEntityObj = entity;
    this.selectedEditEntity = entity.eName;
    this.choosenEntityType = entity.eType;
    this.chooseType(entity.stage);
    this.EntityType = true;
    // this.choosenModule = this.modelData.modules.find(function (mod: any) {
    //   return entity.mID == mod.mID;
    // });
    this.choosenPrimaryEntity = this.modelData.listOfBaseEUTs.find(function (eut: any) {
      return eut.eID == entity.base_eID;
    });
    if (!this.choosenPrimaryEntity) {
      this.choosenPrimaryEntity = {
        "eName": '',
        "eID": ''
      };
    }
  }
  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "RECON");
    setTimeout(() => {
      // if (this.choosenEUT) {
      //   this.loadEntityDetails(this.choosenEUT);
      // }
    }, 500);
  }
  selectedEnvironment(Env: any) {
    // // console.log("env",Env);
    // $('#environmenttextarea').val('');
    this.selectedEnvObj = Env;
    this.selectedEditEnvType = Env.envType;
    this.selectedEditEnvValues = Env.envValues;
  }

  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }

  CreatePersona(newPersonaitem: any) {
    // console.log('newPersona', newPersonaitem);
    // return;
    let newPersona = newPersonaitem.trim();

    var personaCount = 0;
    for (var i = 0; i < this.modelData.persona.length; i++) {
      if (
        this.modelData.persona[i].pName.toLowerCase() ==
        newPersona.toLowerCase()
      ) {
        personaCount++;
        this.duplicateEntity = "'" + newPersona + "'";
        if (this.selectedPersonaObj) {
          if (
            this.modelData.persona[i].pType == this.selectedPersonaObj.pType
          ) {
            personaCount--;
          }
        }
      }
    }
    // console.log('personaCount', personaCount);
    // console.log('obj', this.selectedPersonaObj);
    // // console.log("obj",this.selectedEntityObj);
    if (this.selectedPersonaObj.pType) {
      // console.log('if');
      if (newPersona) {
        if (personaCount > 0) {
          this.errorMessage = 'Already exists!!';
          // this.errorMessage = this.AppService.getResourceText("V030");
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          for (var j = 0; j < this.modelData.persona.length; j++) {
            if (
              this.modelData.persona[j].pType == this.selectedPersonaObj.pType
            ) {
              this.modelData.persona[j]['pName'] = newPersona;
              this.syncModelDataObject = {
                "type": "PERSONA",
                "operation": "UPDATE",
                "data": this.modelData.persona[j]
              }
              this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
            }
          }
        }
      } else {
        this.errorMessage = "Persona can't be empty.";
        $("#duplicateErrorMessagePopupModel").modal("show");
        return;
      }
    } else {
      if (newPersona) {
        if (personaCount > 0) {
          this.errorMessage = 'Already exists!!';
          // this.errorMessage = this.AppService.getResourceText("V030");
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          var Persona = newPersona.trim();
          if (Persona) {
            this.add(Persona, this.modelData.persona.length);
          } else {
            this.errorMessage = "Persona can't be empty.";
            $("#duplicateErrorMessagePopupModel").modal("show");
          }
        }
      } else {
        this.errorMessage = "Persona can't be empty.";
        $("#duplicateErrorMessagePopupModel").modal("show");
      }
    }

    this.selectedPersonaObj = '';
    this.selectedEditPersona = '';
    $('#personatextarea').val('');
  }

  deletePersonaModal() {
    this.duplicateEntity = this.selectedPersonaObj.pName;
    this.errorMessage = 'Would you like to delete?';
    $('#deleteLandscaperErrorMessagePopupModel').modal('show');
  }

  deletePersona() {
    for (var j = 0; j < this.persona.length; j++) {
      if (this.persona[j].pType == this.selectedPersonaObj.pType) {
        this.delete(j, this.selectedPersonaObj.pType);
        // console.log(j, this.selectedPersonaObj);
      }
    }
    this.syncModelDataObject = {
      "type": "PERSONA",
      "operation": "DELETE",
      "data": this.selectedPersonaObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    $('#deleteLandscaperErrorMessagePopupModel').modal('hide');
    this.selectedPersonaObj = '';
    this.selectedEditPersona = '';
    $('#personatextarea').val('');
  }

  // // function to clear persona details when user clicks NO button in delete popup
  clearPersonaDetails() {
    this.selectedPersonaObj = '';
    this.selectedEditPersona = '';
    $('#personatextarea').val('');
  }

  // checkPersona(oldPersona, id) {
  //   var personaCount = 0;
  //   for (var i = 0; i < this.persona.length; i++) {
  //     if (this.persona[i].pName.toLowerCase() == oldPersona.toLowerCase()) {
  //       personaCount++;
  //       this.entityModel.duplicateEntity = oldPersona;
  //       this.duplicatePersonaIndex = i;
  //     }
  //   }
  //   if (personaCount > 1) {
  //     this.entityModel.errorMessage = this.AppService.getResourceText("V030");
  //     $("#duplicateErrorMessagePopupModel").modal("show");
  //     // setTimeout(function () {
  //     //   $("#duplicateErrorMessagePopupModel").modal("hide");
  //     //   this.checkedDuplicate = false;
  //     // }, 1500);
  //     this.checkedDuplicate = true;
  //     this.delete(this.newPersonaID + 1);
  //     return;
  //   } else {
  //     this.add('', id);
  //     this.checkedDuplicate = false;
  //   }
  // }
  // // checkPersonafocus(oldPersona) {
  // //   if (this.checkedDuplicate == false) {
  // //     var personaCount = 0;
  // //     for (var i = 0; i < this.persona.length; i++) {
  // //       if (this.persona[i].pName.toLowerCase() == oldPersona.toLowerCase()) {
  // //         personaCount++;
  // //         this.entityModel.duplicateEntity = oldPersona;
  // //         this.duplicatePersonaIndex = i;
  // //       }
  // //     }
  // //     if (personaCount > 1) {
  // //       this.entityModel.errorMessage = this.AppService.getResourceText("V030");
  // //       $("#duplicateErrorMessagePopupModel").modal("show");
  // //       // setTimeout(function () {
  // //       //   $("#duplicateErrorMessagePopupModel").modal("hide");
  // //       // }, 1500);
  // //       this.delete(this.newPersonaID + 1);
  // //       this.checkedDuplicate = false;
  // //       return;
  // //     }
  // //   }
  // //   this.checkedDuplicate = false;
  // // }
  add(newPerson: any, id: any) {
    this.newPersonaID = id;
    // console.log('newPerson', newPerson);
    var newID = id + 1;
    var newPersonaObj = {
      pName: newPerson,
      pType: this.uniqueID('P'),
    };
    this.modelData.persona.unshift(newPersonaObj);

    this.syncModelDataObject = {
      "type": "PERSONA",
      "operation": "CREATE",
      "data": newPersonaObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }
  //generation of unique id for persona
  uniqueID(type: any) {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    if (type == 'TF' || type == 'UR' || type == 'BF' || type == 'XX') {
      type = 'EUT';
    }
    return (
      type +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  delete(id: any, type: any) {
    // // console.log(id);
    // console.log(type);
    // console.log(this.modelData.persona);
    if (id >= 0) {
      return this.modelData.persona.splice(id, 1);
    }
    // if (this.model.persona.length <= 0) {
    //   this.planner.controller.deleteTaskWithName("Do Persona map");
    // }
    // this.deletePersonaFromScenarios(type);
  }

  // deletePersonaFromScenarios(type) {
  //   for (var i = 0; i < this.scenarios.length; i++) {
  //     this.scenarios[i].persona = this.scenarios[i].persona.filter(pType => pType !== type);
  //   }
  // }
  // //Function to clear th empty list
  // onFocusOut(model, id) {
  //   // if (!model) {
  //   //   this.delete(id);
  //   // }
  //   // if(this.newPersonaID + 1 == id){
  //   //   this.delete(id);
  //   // }
  //   if (!model || model == '') {
  //     this.delete(id);
  //   }
  //   //  else if (this.newPersonaID + 1 == id) {
  //   //   this.delete(id);
  //   // }
  // }
  generateReport(auto: any) {
    let lanscapeArray = [
      'Summary',
      'Modules',
      'Persona',
      'Features',
      'Requirements',
      'Flows',
      'Unspecified',
      'Attributes',
      'Environments',
    ];
    window.localStorage.setItem('exportedData', JSON.stringify(lanscapeArray));
    this.ReportDataRxjsService.sendReportData(lanscapeArray);
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }

  CreateEnvironment(newEnvironmentitem: any) {
    let newEnvironment = newEnvironmentitem.trim();
    var environmentCount = 0;
    for (var i = 0; i < this.modelData.listOfEnv.length; i++) {
      if (
        this.modelData.listOfEnv[i].envType.toLowerCase() ==
        newEnvironment.toLowerCase()
      ) {
        environmentCount++;
        this.duplicateEntity = "'" + newEnvironment + "'";
        // this.entityModel.duplicateEntity = "'" + newEnvironment + "'";
        if (this.selectedEnvObj) {
          if (
            this.modelData.listOfEnv[i].envType == this.selectedEnvObj.envType
          ) {
            environmentCount--;
          }
        }
      }
    }
    // // console.log("obj",this.selectedEnvObj);
    // // console.log("newEnvironment",newEnvironment);
    if (this.selectedEnvObj.envType) {
      if (newEnvironment) {
        // // console.log("1");
        if (environmentCount > 0) {
          this.duplicateEntity = "'" + newEnvironment + "'";
          this.errorMessage = 'Already exists!';
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          for (var j = 0; j < this.modelData.listOfEnv.length; j++) {
            if (
              this.modelData.listOfEnv[j].envType == this.selectedEnvObj.envType
            ) {
              this.modelData.listOfEnv[j]['envType'] = newEnvironment;
              var str = this.selectedEditEnvValues.toString();
              var envValuesArray = str.split(',');
              // console.log("envValuesArray", envValuesArray);
              this.modelData.listOfEnv[j]['envValues'] = envValuesArray;
              this.syncModelDataObject = {
                "type": "ENVIRONMENT",
                "operation": "UPDATE",
                "data": this.modelData.listOfEnv[j]
              }
              this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
            }
          }
        }
      } else {
        // // console.log("2");
        this.errorMessage = "Environment can't be empty.";
        $('#duplicateErrorMessagePopupModel').modal('show');
        return;
      }
    } else {
      if (newEnvironment) {
        if (environmentCount > 0) {
          this.errorMessage = 'Already exists!';
          // this.entityModel.errorMessage = this.AppService.getResourceText("V032");
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          var environment = newEnvironment.trim();
          if (environment) {
            this.addEnv(newEnvironment, this.modelData.listOfEnv.length);
          } else {
            this.errorMessage = "Environment can't be empty.";
            $('#duplicateErrorMessagePopupModel').modal('show');
          }
        }
      } else {
        this.errorMessage = "Environment can't be empty.";
        $('#duplicateErrorMessagePopupModel').modal('show');
      }
    }

    this.selectedEnvObj = '';
    this.selectedEditEnvType = '';
    this.selectedEditEnvValues = '';
    $('#environmenttextarea').val('');
  }

  deleteEnvModal() {
    this.duplicateEntity = this.selectedEnvObj.envType;
    this.errorMessage = 'Would you like to delete?';
    $('#deleteLandscaperEnvErrorMessagePopupModel').modal('show');
  }
  addEnv(newEnvironment: any, id: any) {
    // this.newEnvId = id;
    var str = this.selectedEditEnvValues.toString();
    var envValuesArray = str.split(',');
    // console.log("envValuesArray", envValuesArray);
    var newEnvironmentObj = {
      //eid is the unique id generated for an environment,etype being the type ->tf,bf,fl
      envID: this.uniqueID('E'),
      envType: newEnvironment,
      envValues: envValuesArray,
    };
    var newID = id + 1;
    this.modelData.listOfEnv.unshift(newEnvironmentObj);
    this.syncModelDataObject = {
      "type": "ENVIRONMENT",
      "operation": "CREATE",
      "data": newEnvironmentObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);

  }
  clearEnvDetails() {
    this.selectedEnvObj = '';
    this.selectedEditEnvType = '';
    this.selectedEditEnvValues = '';
    $('#environmenttextarea').val('');
  }
  deleteEnvironment() {
    for (var j = 0; j < this.modelData.listOfEnv.length; j++) {
      if (this.modelData.listOfEnv[j].envType == this.selectedEnvObj.envType) {
        this.deleteEnv(j);
        // console.log(j, this.selectedEnvObj);
      }
    }
    this.syncModelDataObject = {
      "type": "ENVIRONMENT",
      "operation": "DELETE",
      "data": this.selectedEnvObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    $('#deleteLandscaperEnvErrorMessagePopupModel').modal('hide');
    this.selectedEnvObj = '';
    this.selectedEditEnvType = '';
    this.selectedEditEnvValues = '';
  }

  // delete a environment
  // id is the index of the
  deleteEnv(id: any) {
    if (id >= 0) {
      return this.modelData.listOfEnv.splice(id, 1);
    }
  }

  CreateModule(newModuleData: any, type: any) {
    // console.log("NEW", newModuleData);
    let newModule = newModuleData.trim();
    // console.log("A", newModule);
    var moduleCount = 0;
    for (var i = 0; i < this.modelData.modules.length; i++) {
      if (
        this.modelData.modules[i].mName.toLowerCase() ==
        newModule.toLowerCase()
      ) {
        moduleCount++;
        this.duplicateModule = "'" + newModule + "'";
        if (this.selectedModuleObj) {
          if (this.modelData.modules[i].mID == this.selectedModuleObj.mID) {
            moduleCount--;
          }
        }
      }
    }

    if (this.selectedModuleObj.mID) {
      if (newModule) {
        if (moduleCount > 0) {
          this.errorMessage = 'Already exists!';
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          for (var j = 0; j < this.modelData.modules.length; j++) {
            if (
              this.modelData.modules[j].mID == this.selectedModuleObj.mID
            ) {
              this.selectedOldModule = this.modelData.modules[j].mName;
              this.modelData.modules[j]['mName'] = newModule;
              this.syncModelDataObject = {
                "type": "MODULE",
                "operation": "UPDATE",
                "data": this.modelData.modules[j]
              }
              this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
            }
          }

        }
      } else {
        this.errorMessage = "Module can't be empty.";
        $('#duplicateErrorMessagePopupModel').modal('show');
        return;
      }
    } else {
      if (newModule) {
        if (moduleCount > 0) {
          this.errorMessage = 'Already exists!';
          this.duplicateEntity = "'" + newModule + "'";
          // this.model.errorMessage = this.AppService.getResourceText("V031");
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          var newmodule = newModule.trim();
          if (newmodule) {
            this.addModule(newModule, type, this.modelData.modules.length);
          } else {
            this.errorMessage = "Module can't be empty.";
            $('#duplicateErrorMessagePopupModel').modal('show');
          }
        }
      } else {
        this.errorMessage = "Module can't be empty.";
        $('#duplicateErrorMessagePopupModel').modal('show');
      }
    }
    this.selectedModuleObj = '';
    this.selectedEditModule = '';
    $('#moduletextarea').val('');
  }
  clearModuleData() {
    this.selectedModuleObj = '';
    this.selectedEditModule = '';
    $('#moduletextarea').val('');
  }

  deleteModuleModal() {
    this.duplicateEntity = this.selectedModuleObj.mName;
    this.errorMessage = 'Would you like to delete?';
    $('#deleteLandscaperModuleErrorMessagePopupModel').modal('show');
  }

  //adding  a new module
  //id will be the position at which we want to add a new module
  addModule(newModule: any, type: any, id: any) {
    var newModuleObj = {
      //mid is the unique id generated for an module
      mID: this.uniqueID(type),
      mName: newModule,
    };
    var newID = id + 1;
    this.modelData.modules.unshift(newModuleObj);
    this.syncModelDataObject = {
      "type": "MODULE",
      "operation": "CREATE",
      "data": newModuleObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }

  CreateEntity(newEntityData: any) {
    let newEntity = newEntityData.trim();
    var entityCount = 0;
    for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
      if (
        this.modelData.listOfEUTs[i].eName.toLowerCase() ==
        newEntity.toLowerCase() && this.modelData.listOfEUTs[i].mID == this.choosenModule.mID
      ) {
        entityCount++;
        this.duplicateEntity = "'" + newEntity + "'";
        if (this.selectedEntityObj) {
          if (this.modelData.listOfEUTs[i].eID == this.selectedEntityObj.eID) {
            entityCount--;
          }
        }
      }
    }
    if (this.selectedEntityObj.eID) {
      if (newEntity) {
        if (entityCount > 0) {
          this.errorMessage = 'Already exists!';
          this.duplicateEntity = "'" + newEntity + "'";
          // this.model.errorMessage = this.AppService.getResourceText("V031");
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
            if (
              this.modelData.listOfEUTs[j].eID == this.selectedEntityObj.eID
            ) {
              // // console.log("i",this.modelData.listOfEUTs[j]);
              if (this.modelData.listOfEUTs[j].eType != this.choosenEntityType || this.modelData.listOfEUTs[j].eName != newEntity) {
                this.updateEUTtasks(this.modelData.listOfEUTs[j].eType, this.choosenEntityType, this.modelData.listOfEUTs[j].eID, newEntity);
              }
              if (this.modelData.listOfEUTs[j].baseEntity_Id != this.choosenPrimaryEntity.eID) {
                this.updateBaseReTestTask(this.modelData.listOfEUTs[j].eID, this.modelData.listOfEUTs[j].baseEntity_Id, this.choosenPrimaryEntity.eID);
              }
              this.selectedOldEntity = this.modelData.listOfEUTs[j].eName;
              this.modelData.listOfEUTs[j]['eType'] = this.choosenEntityType;
              this.modelData.listOfEUTs[j]['eName'] = newEntity;
              // console.log("this.choosenPrimaryEntity", this.choosenPrimaryEntity);
              this.modelData.listOfEUTs[j]['base_eID'] = this.choosenPrimaryEntity.eID;
              this.syncModelDataObject = {
                "type": "ENTITY",
                "operation": "UPDATE",
                "data": this.modelData.listOfEUTs[j]
              }
              this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);

            }
          }
          this.clearEntityDetails();

        }
      } else {
        this.errorMessage = "Entity can't be empty.";
        $('#duplicateErrorMessagePopupModel').modal('show');
        return;
      }
    } else {
      if (newEntity) {
        if (entityCount > 0) {
          this.errorMessage = 'Already exists!';
          // this.model.errorMessage = this.AppService.getResourceText("V031");
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          var entity = newEntity.trim();
          if (entity) {
            this.addEUT(newEntity, this.modelData.listOfEUTs.length);
          } else {
            this.errorMessage = "Entity can't be empty.";
            $('#duplicateErrorMessagePopupModel').modal('show');
          }
        }
      } else {
        this.errorMessage = "Entity can't be empty.";
        $('#duplicateErrorMessagePopupModel').modal('show');
      }
    }

    this.selectedEntityObj = '';
    this.selectedEditEntity = '';
    $('#entitytextarea').val('');
  }

  deleteEntityModal() {
    this.duplicateEntity = this.selectedEntityObj.eName;
    this.errorMessage = 'Would you like to delete?';
    $('#deleteLandscaperEntityErrorMessagePopupModel').modal('show');
  }
  addEntity(newEntity: any, id: any) {
    this.newCreatedID = id;
    var controller = this;
    this.addEUT(newEntity, id);
  }

  //adding  a new entity
  //id will be the position at which we want to add a new entity
  addEUT(newEntity: any, id: any) {
    // console.log("this.choosenModule.mID",this.choosenModule.mID);
    if (this.choosenModule.mID == "" || this.choosenModule.mID == undefined) {
      this.errorMessage = "Please select module to add entity";
      $('#duplicateErrorMessagePopupModel').modal('show');
    } else {
      var newEntityObj: any = {
        //eid is the unique id generated for an entity,etype being the type ->tf,bf,fl
        eID: this.uniqueID(this.choosenEntityType),
        eType: this.choosenEntityType,
        eName: newEntity,
        mID: this.choosenModule.mID,
        stage: this.choosenType
      };

      if (this.choosenPrimaryEntity.eName != '') {
        newEntityObj['base_eID'] = this.choosenPrimaryEntity.eID;
      }
      var newID = id + 1;
      // console.log("newEntityObj", newEntityObj);
      this.modelData.listOfEUTs.unshift(newEntityObj);
      this.syncModelDataObject = {
        "type": "ENTITY",
        "operation": "CREATE",
        "data": newEntityObj
      }
      this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      this.generateTasks(newEntityObj);
      this.clearEntityDetails();
    }
  }


  deleteEUT(eID: any) {
    for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
      if (this.modelData.listOfEUTs[j].eID == eID) {
        if (j >= 0) {

          this.modelData.listOfEUTs.splice(j, 1);

        }
      }
    }
    this.clearEntityDetails();
    this.reloadToolService.triggerToolSprint(this.modelData.tasks);
    $('#deleteLandscaperEntityErrorMessagePopupModel').modal('hide');

    // this.taskPlannerComponent.loadPlanNamesList(this.modelData.tasks);
    // this.taskPlannerComponent.selectedPlan(false, false, '');
  }
  deleteEUTdata() {
    this.deleteTasksByeutID(this.selectedEntityObj.eID);
  }
  deleteTasksByeutID(eID: any) {
    this.syncModelDataObject = {
      "type": "ENTITY",
      "operation": "DELETE",
      "data": eID
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    for (var k = 0; k < this.modelData.tasks.length; k++) {
      if (this.modelData.tasks[k].entity_Id == eID) {
        this.modelData.tasks.splice(k, 1);
        k--;
      }
    }
    for (var n = 0; n < this.modelData.tasks.length; n++) {
      if (this.modelData.tasks[n].primaryentity_Id != "") {
        if (this.modelData.tasks[n].primaryentity_Id == eID) {
          this.modelData.tasks.splice(n, 1);
          n--;
        }
      }
    }

    for (var l = 0; l < this.modelData.EUTdetails.length; l++) {
      if (this.modelData.EUTdetails[l].eID == eID) {
        this.modelData.EUTdetails.splice(l, 1);
        l--;
      }
    }

    for (var o = 0; o < this.modelData.scenarios.length; o++) {
      if (this.modelData.scenarios[o].eID == eID) {
        this.modelData.scenarios.splice(o, 1);
        o--;
      }
    }

    for (var m = 0; m < this.modelData.interactionMap.length; m++) {
      if (this.modelData.interactionMap[m].eut2 == eID || this.modelData.interactionMap[m].eut1 == eID) {
        this.modelData.interactionMap.splice(m, 1);
        m--;
      }
    }
    this.deleteEUT(eID);
  }

  deleteModuledata() {
    // console.log("this.choosenModule", this.choosenModule);
    // this.deleteTasksByeutID(this.selectedEntityObj.eID);
    for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
      if (this.modelData.listOfEUTs[i].mID == this.choosenModule.mID) {
        this.deleteTasksByeutID(this.modelData.listOfEUTs[i].eID);
        i--;
      }
      // if (i == this.modelData.listOfEUTs.length - 1) {
      //   this.choosenModule = {
      //     "mName": '',
      //     "mID": ''
      //   };
      // }
    }
    for (var j = 0; j < this.modelData.modules.length; j++) {
      if (this.modelData.modules[j].mID == this.choosenModule.mID) {
        this.modelData.modules.splice(j, 1);
        this.syncModelDataObject = {
          "type": "MODULE",
          "operation": "DELETE",
          "data": this.choosenModule
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }
    this.choosenModule = {
      "mName": '',
      "mID": ''
    };
    this.clearModuleDetails();
    this.clearEntityDetails();
    this.clearModuleData();
  }


  clearEntityDetails() {
    // this.choosenEntityType = "UR";
    this.chooseType('NEW');
    this.selectedEditEntity = '';
    this.EntityType = false;
    $('#entitytextareaUR').val('');
    this.selectedEntityObj = { "eName": '', "eID": '' };

  }

  clearModuleDetails() {
    this.selectedModuleObj = {};
    this.choosenModule = {
      "mName": '',
      "mID": ''
    };
  }

  updateEUTtasks(eType: any, neweType: any, eID: any, eName: any) {

    if (neweType != 'UR' && eType == 'UR') {
      for (var k = 0; k < this.modelData.tasks.length; k++) {
        if (this.modelData.tasks[k].entity_Id == eID && this.modelData.tasks[k].toolType == "pm") {
          this.modelData.tasks.splice(k, 1);
        }

      }
    }
    if (eType != 'UR' && neweType != 'UR') {
      for (var k = 0; k < this.modelData.tasks.length; k++) {
        if (this.modelData.tasks[k].entity_Id == eID) {
          this.modelData.tasks[k]['entityType'] = neweType;
          this.modelData.tasks[k]['entity_desc'] = eName;
        }

      }
    }
    if (eType != 'UR' && neweType == 'UR') {
      var foundTask: any = this.modelData.tasks.find(
        (task: any) => task.entity_Id == eID
      );

      var foundEUT: any = this.modelData.listOfEUTs.find(
        (eut: any) => eut.eID == eID
      );
      var assignedUser = {
        "id": foundTask.assignedto,
        "name": foundTask.assigneduser
      }
      // console.log("foundTask", foundTask);
      // console.log("assignedUser", assignedUser);
      // console.log("foundEUT", foundEUT);
      this.generateTaskObj(foundEUT, foundTask.task_combine_id, assignedUser, "pm", this.choosenPrimaryEntity.eID);
    }

  }

  updateBaseReTestTask(eID: any, oldBase_eID: any, base_eID: any) {
    for (var k = 0; k < this.modelData.tasks.length; k++) {
      if (this.modelData.tasks[k].entity_Id == eID && this.modelData.tasks[k].baseEntity_Id == oldBase_eID) {
        this.modelData.tasks[k]['baseEntity_Id'] = base_eID;
      }

    }
  }

  generateTasks(entity: any) {
    let taskCombineUUID: any = this.uuidv4();
    let assignedUser: any;
    // if (this.modelData.invites.length > 1) {
    assignedUser = {
      "id": '',
      "name": ''
    }
    // } else {
    //   assignedUser = {
    //     "id": this.loginDetails.userId,
    //     "name": this.loginDetails.user_display_name
    //   }
    // }
    let taskCreateArray: any = '';
    if (entity.stage == 'NEW') {

      if (this.choosenEntityType == 'UR') {
        taskCreateArray = ['pm', 'sc', 'im', 'dd'];
      } else {
        taskCreateArray = ['sc', 'im', 'dd'];
      }

    } else if (entity.stage == 'MOD') {
      taskCreateArray = ['dd', 'de', 'ex', 'bex'];
    } else if (entity.stage == 'FIX') {
      taskCreateArray = ['de', 'ex', 'bex'];
    }

    for (var i = 0; i < taskCreateArray.length; i++) {
      this.generateTaskObj(entity, taskCombineUUID, assignedUser, taskCreateArray[i], this.choosenPrimaryEntity.eID);
    }
  }

  generateTaskObj(entity: any, taskCombineUUID: any, assignedUser: any, toolType: any, primaryEntityID: any) {
    let taskObj: any = {};
    taskObj.task_combine_id = taskCombineUUID;
    taskObj.assignedto = assignedUser.id;
    taskObj.assigneduser = assignedUser.name;

    // taskObj.attribute = attribute;
    // taskObj.activity = { type: 'RI', name: 'IMP' };
    // taskObj.environment = this.model.choosenEntity.environment;
    if (entity.stage == 'MOD' || entity.stage == 'FIX') {
      var attribute: any = {};
      if (entity.eType == "TF" || entity.eType == "XX") {
        attribute = {
          name: "Feature Behaviour",
          symbol: "Fe",
          level: "L4"
        };
      } else if (entity.eType == "UR") {
        attribute = {
          name: "Requirement Behaviour",
          symbol: "Rb",
          level: "L5"

        };
      } else if (entity.eType == "BF") {
        attribute = {
          name: "Flow Behaviour",
          symbol: "Fb",
          level: "L5"
        };
      }
      // var primaryEntity = this.modelData.tasks.find((eut: any) => (eut.entity_Id == primaryEntityID && eut.toolType == 'ex'));
      taskObj.baseEntity_Id = this.choosenPrimaryEntity.eID;
      var primaryEntity = { "eName": "Anonymous" };
      if (this.choosenPrimaryEntity.eID) {
        primaryEntity = this.modelData.listOfBaseEUTs.find((eut: any) => eut.eID == this.choosenPrimaryEntity.eID);
      }
      if (toolType == 'bex') {
        taskObj.task_desc = '(re)' + this.generateTaskDesc(toolType, primaryEntity.eName, attribute.name);
      } else {
        taskObj.task_desc = '(re)' + this.generateTaskDesc(toolType, entity.eName, attribute.name);
      }
      taskObj.attribute = attribute;
      taskObj.activity = { type: 'RM', name: 'Re-test', shortfrom: 'R-Test' };
    } else {
      taskObj.task_desc = this.generateTaskDesc(toolType, entity.eName, '');
      taskObj.activity = { type: 'TN', name: 'Test', shortfrom: 'Test' };
    }
    taskObj.toolType = toolType;
    taskObj.moduleName = this.choosenModule.mName;
    taskObj.moduleID = this.choosenModule.mID;
    taskObj.entity_Id = entity.eID;
    taskObj.entity_desc = entity.eName;
    taskObj.entityType = entity.eType;
    taskObj.primaryentity_Id = "";
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.status = 1;
    taskObj.taskId = this.uuidv4();
    // taskObj.impactedUnquieID = impactedUnquieID;
    taskObj.createdOn = new Date();
    // console.log("taskObj", taskObj);
    this.modelData.tasks.push(taskObj);
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "CREATE",
      "data": taskObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.modelData.tasks", this.modelData.tasks);
    this.reloadToolService.triggerToolSprint(this.modelData.tasks);
  }

  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('ls');

    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }


  generateTaskDesc(type: any, eName: any, attribute: any) {
    var description: any;
    if (type == 'pm') {
      description = "do Persona map";
    } else if (type == 'im') {
      description = "do Interaction map";
    } else if (type == 'sc') {
      description = "do Scope map";
    } else if (type == 'dd') {
      description = "do Deep dive ";
    } else if (type == 'de') {
      description = 'do Design for ' + attribute;
    } else if (type == 'ex') {
      description = 'do Test for ' + attribute;
    } else if (type == 'bex') {
      description = 'do reTest for ' + attribute;
    }
    return description;
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  //sort by alphabetical order
  sortBy(prop: string) {
    return this.modelData.modules.sort((a: any, b: any) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo'
      }), '*');
    });
  }

  clearLastId() { }
  selectedEtype(eutType: any) {
    // console.log(eutType);
  }
  getVideoURL(urlName: any) {
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  loadBugList() {
    window.open('/jirabugslist', '_blank');
  }

  sendJson() {
    var mindMapList = ["Personas", "Modules", "Environments", "Attributes"];
    // console.log("this.modelData", this.modelData);
    this.childrenArray = [];
    for (var i = 0; i < mindMapList.length; i++) {
      if (mindMapList[i] == "Modules") {
        let modulesObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
          // "expanded": false,
          // tags: ['Tag'],
          // "icons": ['😀'],
        };
        let modulesSubchild: any = []
        for (var j = 0; j < this.modulesData.length; j++) {
          let module: any = {};
          module['topic'] = this.modulesData[j].mName
          module['id'] = this.modulesData[j].mID
          module['expanded'] = true
          let entitySubchild: any = []
          for (var l = 0; l < this.listOfEUTs.length; l++) {
            if (this.modulesData[j].mID == this.listOfEUTs[l].mID) {
              let entity: any = {};
              entity['topic'] = '(' + this.listOfEUTs[l].eType + ') ' + this.listOfEUTs[l].eName
              entity['id'] = this.listOfEUTs[l].eID

              entitySubchild.push(entity)
            }
          }
          if (this.listOfEUTs.length > 22) {
            module['expanded'] = false
          }
          module['children'] = entitySubchild;
          module['topic'] = this.modulesData[j].mName + ' (' + entitySubchild.length + ')';
          modulesSubchild.push(module);
        };
        modulesObject['children'] = modulesSubchild;
        modulesObject['topic'] = mindMapList[i] + ' (' + modulesSubchild.length + ')';
        this.childrenArray.push(modulesObject);
      }
      if (mindMapList[i] == "Personas") {
        let personaObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
          // "expanded": false,
          // "icons": ["\f007"],
          // "style": { fontSize: '32', color: '#3298db', background: '#ecf0f1' },
        }
        let personasSubchild: any = [];
        for (let k = 0; k < this.persona.length; k++) {
          let persona: any = {};
          persona['topic'] = this.persona[k].pName
          persona['id'] = this.persona[k].pID

          personasSubchild.push(persona);
        }
        personaObject['children'] = personasSubchild;
        personaObject['topic'] = mindMapList[i] + ' (' + personasSubchild.length + ')';
        this.childrenArray.push(personaObject);
      }
      if (mindMapList[i] == "Attributes") {
        let attributesObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
          // "expanded": false,
        }
        let attributeSubchild: any = [];
        for (let k = 0; k < this.Config.listOfAttributesUpdated.length; k++) {

          var AttributeDesc = this.getAttributeDesc(this.Config.listOfAttributesUpdated[k])
          if (AttributeDesc != "") {
            let attribute: any = {};
            attribute['topic'] = this.Config.listOfAttributesUpdated[k].name + ' : ' + AttributeDesc
            attribute['id'] = this.uuidv4()
            attributeSubchild.push(attribute);
          }
        }
        attributesObject['children'] = attributeSubchild;
        attributesObject['topic'] = mindMapList[i] + ' (' + attributeSubchild.length + ')';
        this.childrenArray.push(attributesObject);
      }
      if (mindMapList[i] == "Environments") {
        let environmentObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
          // "expanded": false,
        }
        let environmentsSubchild: any = [];
        for (let k = 0; k < this.listOfEnv.length; k++) {
          let environment: any = {};
          environment['topic'] = this.listOfEnv[k].envType + ' : ' + this.listOfEnv[k].envValues
          environment['id'] = this.listOfEnv[k].envID

          environmentsSubchild.push(environment);
        }
        environmentObject['children'] = environmentsSubchild;
        environmentObject['topic'] = mindMapList[i] + ' (' + environmentsSubchild.length + ')';
        this.childrenArray.push(environmentObject);
      }
      // if (mindMapList[i] == "Levels") {
      //   let levelObject: any = {
      //     "topic": mindMapList[i],
      //     "id": this.uuidv4()
      //   }
      //   this.childrenArray.push(levelObject);
      // }
    }
    this.nodeData = {
      "id": this.modelData._id,
      "topic": this.modelData.projectDetails.name,
      "root": true,
      "children": this.childrenArray
    };

    this.mindMapData = {
      "nodeData": {
        "id": "8ae27e0480b98558",
        "topic": "Entity",
        "root": true,
        "children": [
          {
            "topic": "Personas",
            "id": "8ae28030353a5bd1",
            "children": [
              {
                "topic": "Admin",
                "id": "8ae281d371bbd6e8"
              },
              {
                "topic": "Manager",
                "id": "8ae28323068d2ca4"
              }
            ]
          },
          {
            "topic": "EUT 1",
            "id": "8ae285dc1ebc3093"
          }
        ]
      },
      "linkData": {},
      "direction": 0,
      "theme": {
        "name": "Latte",
        "palette": [
          "#dd7878",
          "#ea76cb",
          "#8839ef",
          "#e64553",
          "#209fb5",
          // "#df8e1d",
          // "#40a02b",
          // "#209fb5",
          // "#1e66f5",
          // "#7287fd"
        ],
        "cssVar": {
          "--main-color": "#444446",
          "--main-bgcolor": "#ffffff",
          "--color": "#777777",
          "--bgcolor": "#f6f6f6"
        }
      }
    };
    // console.log("nodeData", this.nodeData);
    this.mindMapData['nodeData'] = this.nodeData;
    // const url = 'http://localhost:4300/' + new URLSearchParams(this.mindMapData).toString();
    // console.log("url",url);
    // window.open(url, '_blank');
    // this.router.navigate(['/receiving-app-route'], { queryParams: this.mindMapData });
    // console.log("mindMapData", this.mindMapData);
    var mindMapData = {
      "projectID": window.localStorage.getItem("projectID"),
      "projectJson": this.mindMapData,
      "projectName": this.modelData.projectDetails.name
    }

    this.ProjectServices.addMindMappingData(mindMapData).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          console.log("response", response);
          // const url = 'http://localhost:64758/?projectID=' + mindMapData.projectID
          const url = 'http://dosmartqa.stagsoftware.net:4009/?projectID=' + mindMapData.projectID
          window.open(url, '_blank');
        } else if (response.statusCode === 500) {
        }
      }
    );

  }


  updateAttributeDesc(attribute: any, desc: any) {
    if (this.modelData.listOfAttributes.length > 0) {
      var index = this.modelData.listOfAttributes.findIndex((attr: any) => attr.symbol == attribute.symbol)
      if (index >= 0) {
        this.modelData.listOfAttributes[index]['description'] = desc;
        this.syncModelDataObject = {
          "type": "ATTRIBUTE",
          "operation": "UPDATE",
          "data": attribute,
          "desc": desc
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      } else {
        attribute['description'] = desc;
        this.modelData.listOfAttributes.push(attribute);
        this.syncModelDataObject = {
          "type": "ATTRIBUTE",
          "operation": "CREATE",
          "data": attribute,
          "desc": desc
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
        return;
      }

    } else {
      attribute['description'] = desc;
      this.modelData.listOfAttributes.push(attribute);
      this.syncModelDataObject = {
        "type": "ATTRIBUTE",
        "operation": "CREATE",
        "data": attribute,
        "desc": desc
      }
      this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      return;
    }
  }

  getAttributeDesc(attribute: any) {
    if (this.modelData.listOfAttributes.length > 0) {
      var index = this.modelData.listOfAttributes.find((attr: any) => attr.symbol == attribute.symbol)
      if (index) {
        return index.description
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

}
